<template>
  <div class="px-sm-4">
    <b-card body-class="p-md-1 p-0">
      <b-card-header class="align-items-start flex-sm-row flex-column-reverse">
        <b-card-title class="mt-sm-0 mt-2">
          <b-media class="align-items-center">
            <template #aside>
              <div
                v-if="logoPreview || logo"
                class="bg-dark d-flex justify-content-center align-items-center bg-secondary rounded-avatar"
                style="height: 100px"
              >
                <b-img
                  ref="previewEl"
                  :src="logoPreview || logo || errorImage"
                  :alt="name"
                  width="100px"
                  style="max-height: 100px"
                  rounded
                  class="p-25"
                  @error="setAltImg"
                />
              </div>
              <b-avatar
                ref="previewEl"
                :alt="name"
                size-md="100px"
                size="80px"
                class="bg-secondary text-muted rounded-avatar"
                v-else
              >
              </b-avatar>
            </template>
            <h5 class="mb-1 text-white">
              {{ $route.params.id ? "Edit broker" : "Create broker" }}
            </h5>
            <div class="d-flex flex-wrap">
              <b-button
                class="gradient-btn ml-50 px-75"
                @click="$refs.previewLogo.click()"
              >
                <input
                  @input="changeLogo"
                  ref="previewLogo"
                  type="file"
                  class="d-none"
                  accept="image/*"
                />
                <span class="d-none d-sm-inline">Upload</span>
                <feather-icon icon="EditIcon" class="d-inline d-sm-none" />
              </b-button>
              <b-button
                class="ml-50 px-75"
                @click="removeLogo"
                :disabled="!$route.params.id || !logo"
              >
                <feather-icon icon="TrashIcon" />
              </b-button>
            </div>
          </b-media>
        </b-card-title>

        <b-link :to="{ name: 'brokers' }">
          <span>back to the broker list </span>
          <feather-icon icon="ChevronRightIcon"
        /></b-link>
      </b-card-header>
      <b-card-body>
        <validation-observer ref="createForm">
          <b-form class="form mt-2" @submit.prevent="createForm">
            <b-row>
              <b-col class="d-flex" lg="12">
                <b-form-group label-for="type" class="w-100" label="Type">
                  <b-button-group class="mb-md-1 mt-50">
                    <b-button
                      class="mr-50"
                      :variant="type == 'DEMO' ? 'warning' : 'outline-warning'"
                      @click="type = 'DEMO'"
                    >
                      Forex demo
                    </b-button>
                    <b-button
                      class="ml-50"
                      :variant="type == 'REAL' ? 'warning' : 'outline-warning'"
                      @click="type = 'REAL'"
                    >
                      Forex real
                    </b-button>
                  </b-button-group>
                </b-form-group>
              </b-col>
              <b-col class="d-flex" lg="4">
                <b-form-group label-for="name" class="w-100" label="Name">
                  <validation-provider
                    #default="{ errors }"
                    name="Name"
                    rules="required"
                  >
                    <b-form-input
                      id="name"
                      v-model="name"
                      name="name"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col class="d-flex" lg="4">
                <b-form-group
                  label-for="broker"
                  class="w-100"
                  label="Select broker"
                >
                  <validation-provider #default="{ errors }" name="broker">
                    <select-servers
                      id="broker"
                      v-model="broker"
                      class="w-100"
                      searchable
                      label="name"
                      url="meta-trader/brokers"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col class="d-flex align-items-center my-2" lg="4">
                <b-form-group
                  class="w-100 d-flex align-items-center mb-0 warning-button"
                >
                  <b-form-checkbox
                    v-model="active"
                    name="active"
                    switch
                    inline
                    :uncheckedValue="0"
                    :value="1"
                  >
                    active
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <template v-if="servers.length">
                <b-col
                  class="d-flex"
                  lg="4"
                  v-for="(server, index) in servers"
                  :key="index"
                >
                  <b-form-group
                    label-for="servers"
                    class="w-100"
                    :label="`Server ${index + 1}`"
                  >
                    <validation-provider
                      #default="{ errors }"
                      :name="`servers ${index + 1}`"
                      rules="required"
                    >
                      <b-form-input
                        :id="`server${index + 1}`"
                        v-model="servers[index]"
                        name="name"
                        :state="errors.length > 0 ? false : null"
                      />
                      <b-button
                        variant="outline-danger"
                        @click="servers.splice(index, 1)"
                        size="sm"
                        class="mt-50"
                      >
                        remove server
                      </b-button>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col class="d-flex" lg="12">
                  <b-button
                    variant="outline-primary"
                    @click="servers.push('')"
                    class="my-2"
                  >
                    Add server
                  </b-button>
                </b-col>
              </template>
              <b-col class="d-flex" lg="8">
                <b-form-group
                  label-for="description"
                  class="w-100"
                  label="Description"
                >
                  <validation-provider #default="{ errors }" name="Description">
                    <b-form-textarea
                      id="description"
                      v-model="description"
                      name="description"
                      :state="errors.length > 0 ? false : null"
                      rows="4"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col class="d-flex flex-column mb-2 py-0 px-md-2 px-1" lg="4">
                <b-form-group
                  class="w-100 position-relative"
                  label="Upload cover"
                >
                  <div
                    v-if="coverPreview || cover"
                    class="d-flex align-items-center justify-content-center py-3"
                  >
                    <b-img
                      ref="previewEl"
                      :src="coverPreview || cover || errorImage"
                      :alt="name"
                      fluid
                      rounded
                      class="p-25"
                      @error="setAltImg"
                    />
                  </div>
                  <b-avatar
                    ref="previewEl"
                    :alt="name"
                    style="height: 140px; width: 100%"
                    rounded
                    class="bg-secondary text-muted"
                    v-else
                  >
                    <feather-icon icon="ImageIcon" size="60" class="mb-3" />
                  </b-avatar>
                  <div
                    class="d-flex w-100 justify-content-center banner-btns flex-wrap my-2"
                  >
                    <b-button
                      :class="[
                        coverPreview || cover ? 'gradient-btn' : 'border',
                        'ml-50 px-75',
                      ]"
                      @click="$refs.refInputEl.click()"
                    >
                      <input
                        @input="changeCover"
                        ref="refInputEl"
                        type="file"
                        class="d-none"
                        accept="image/*"
                      />
                      <span class="d-none d-sm-inline">Upload</span>
                      <feather-icon
                        icon="EditIcon"
                        class="d-inline d-sm-none"
                      />
                    </b-button>
                    <b-button
                      class="ml-50 px-75 border"
                      @click="removeCover"
                      :disabled="!$route.params.id || !cover"
                    >
                      <feather-icon icon="TrashIcon" />
                    </b-button>
                  </div>
                </b-form-group>
              </b-col>
            </b-row>
            <div class="d-flex align-items-center justify-content-end">
              <b-button class="gradient-btn" type="submit"> submit </b-button>
            </div>
          </b-form>
        </validation-observer>
      </b-card-body>
    </b-card>
    <loader :loading="loading" />
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BRow,
  BCol,
  BCard,
  BCardHeader,
  BCardTitle,
  BCardBody,
  BButtonGroup,
  BButton,
  BForm,
  BFormInput,
  BFormGroup,
  BLink,
  BInputGroup,
  BInputGroupAppend,
  BFormCheckbox,
  BFormTextarea,
  BMedia,
  BAvatar,
  BImg,
} from "bootstrap-vue";
import { required } from "@validations";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Loader from "@/@core/components/loader/Loader.vue";
import SelectServers from "./SelectServers.vue";
export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BButtonGroup,
    BButton,
    BForm,
    BFormInput,
    BFormGroup,
    BLink,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox,
    Loader,
    BFormTextarea,
    BMedia,
    BAvatar,
    BImg,
    SelectServers,
  },
  data() {
    return {
      name: "",
      type: "DEMO",
      description: "",
      active: 1,
      logo: "",
      servers: [],
      logoPreview: "",
      cover: "",
      coverPreview: "",
      broker: "",
      loading: false,
      // validation rules
      required,
    };
  },
  created() {
    if (this.$route.params.id) {
      this.getBroker();
    }
  },
  computed: {
    finalServers() {
      return this.servers.length ? this.servers : [];
    },
  },
  watch: {
    broker: {
      handler(val) {
        this.servers = val && val.access ? val.access : [];
      },
      deep: true,
    },
  },

  methods: {
    async removeCover() {
      this.loading = true;
      if (this.$route.params.id) {
        try {
          await this.$http.delete(
            `panel/brokers/${this.$route.params.id}/cover`
          );
          await this.getBroker();
        } catch (err) {}
      } else {
        this.cover = "";
        this.coverPreview = "";
        this.$refs.refInputEl.value = "";
      }
      this.loading = false;
    },
    async removeLogo() {
      this.loading = true;
      if (this.$route.params.id) {
        try {
          await this.$http.delete(
            `panel/brokers/${this.$route.params.id}/logo`
          );
          await this.getBroker();
        } catch (err) {}
      } else {
        this.$refs.previewLogo.value = "";
        this.logo = "";
        this.logoPreview = "";
      }
      this.loading = false;
    },
    async changeCover(e) {
      this.loading = true;
      if (this.$route.params.id) {
        try {
          let formData = new FormData();
          formData.append("cover", e.target.files[0]);
          const { data } = await this.$http.post(
            `panel/brokers/${this.$route.params.id}/cover?_method=patch`,
            formData
          );
          this.$refs.refInputEl.value = "";
          await this.getBroker();
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Broker cover Updated",
              icon: "EditIcon",
              variant: "success",
            },
          });
        } catch (err) {}
      } else {
        this.cover = e.target.files[0];
        this.coverPreview = URL.createObjectURL(this.cover);
      }
      this.loading = false;
    },
    async changeLogo(e) {
      this.loading = true;
      if (this.$route.params.id) {
        try {
          let formData = new FormData();
          formData.append("logo", e.target.files[0]);
          const { data } = await this.$http.post(
            `panel/brokers/${this.$route.params.id}/logo?_method=patch`,
            formData
          );
          this.$refs.previewLogo.value = "";
          await this.getBroker();
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Broker logo Updated",
              icon: "EditIcon",
              variant: "success",
            },
          });
        } catch (err) {}
      } else {
        this.logo = e.target.files[0];
        this.logoPreview = URL.createObjectURL(this.logo);
      }
      this.loading = false;
    },
    async getBroker() {
      this.loading = true;
      try {
        const { data } = await this.$http.get(
          `/panel/brokers/${this.$route.params.id}`
        );
        await Object.keys(data.data).map((item) => {
          if (item == "active") {
            this[item] = data.data[item] ? 1 : 0;
          } else {
            this[item] = data.data[item];
          }
        });
      } catch (err) {}
      this.loading = false;
    },
    createForm() {
      this.$refs.createForm.validate().then(async (success) => {
        if (success) {
          this.loading = true;
          try {
            this.formData = await new FormData();
            let newObject = await {
              name: this.name,
              type: this.type,
              servers: this.finalServers,
              active: this.active,
              description: this.description,
              active: this.active,
            };

            (await !this.$route.params.id) && this.logo
              ? (newObject.logo = this.logo)
              : "";
            (await !this.$route.params.id) && this.cover
              ? (newObject.cover = this.cover)
              : "";
            await Object.keys(newObject).map((item, index) => {
              this.setFormData(newObject[item], index, item);
            });

            if (this.$route.params.id) {
              const { data } = await this.$http.post(
                `panel/brokers/${this.$route.params.id}?_method=put`,
                this.formData
              );
              await this.getBroker();
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Broker Updated",
                  icon: "EditIcon",
                  variant: "success",
                },
              });
            } else {
              const { data } = await this.$http.post(
                "panel/brokers",
                this.formData
              );
              this.$router.push({ name: "brokers" });
            }
          } catch (err) {}
          this.loading = false;
        }
      });
    },
  },
};
</script>

<style></style>
